var map = {
	"./images/landscape.jpg": 3265,
	"./images/moonEclipse.jpg": 3266,
	"./images/territory.jpg": 3267,
	"./images/wolfCubs.jpg": 3268,
	"./images/wolfHowl.jpg": 3269,
	"./images/wolfHunt.jpg": 3270,
	"./images/wolfMoon.jpg": 3271,
	"./images/wolfPups.jpg": 3272,
	"./images/wolfpack.jpg": 3273
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3305;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/images\/[^\/]+\.(jpg|jpeg|png)$
// module id = 3305
// module chunks = 0